import React, { useRef, useEffect, useState } from "react"
import _ from "lodash"
import { TableDropdown_s } from 'styles/input-styles'
import { local } from 'data/lib/local-json'

export type DropdownInterface = {
  attrs?: Function
  disabled?: boolean
  rowData: {}
  field: string|string[]
  filter?: boolean
  options: Array<{label: string, value: string}> | string[]
  persist: Function
  className?: string
  default?: string
}

const DropdownEdit = (props: DropdownInterface) => {
  const dropdownRef = useRef(null);
  const [dropUp, setDropUp] = useState(false);

  const table = local('tableid').replace(/table/g, "").replace(/-/g, "")
  const attrs = (props.attrs && props.attrs(props.field)) || {}

  const value = !_.isNil(_.get(props.rowData, props.field))
    ? _.get(props.rowData, props.field)
    : props.default
    ? props.default
    : null

  useEffect(() => {
    const findContainerBottom = (ele, tableBottom?) => {
      if(!ele || !ele.parentElement) return window.innerHeight-60
      else if(ele.className.includes('p-datatable-scrollable-body')) return findContainerBottom(ele.parentElement, _.get(_.invoke(ele, "getBoundingClientRect"), "bottom"))
      else if(ele.className.includes('panel')) {
        const panelBottom = _.get(_.invoke(ele, "getBoundingClientRect"), "bottom")
        return Math.min(panelBottom, tableBottom)
      }
      else return findContainerBottom(ele.parentElement, tableBottom)
    }

    if (dropdownRef.current) {
      const rect = _.invoke(dropdownRef.current, "getBoundingClientRect")
      const viewportBottom = findContainerBottom(dropdownRef.current)
      const dropdownHeight = 24*_.clamp(props.options.length, 1, 5)+20
      setDropUp(rect.bottom + dropdownHeight > viewportBottom)
    }
  }, [dropdownRef])

  return (
    <div
      ref={dropdownRef}
      data-id={props.rowData[`${table}id`]}
      data-field={props.field}
      {...attrs}
    >
      <TableDropdown_s
        className={`${props.className} ${dropUp ? 'drop-up' : ''}`}
        disabled={props.disabled || false}
        value={value}
        options={props.options}
        onChange={(e) => props.persist(e.value, props.field, props.rowData)}
        filter={props.filter || false}
      />
    </div>
  );
};

export default DropdownEdit
